<template>
  <div class="deviceInfo_cla">
    <div class="search-bar-margin-bottom-cla">
      <div class="search_bar-cla">
        <div style="display:flex">
          <el-select
            v-model="params.devStatus"
            clearable
            :placeholder="$t('device.deviceSelectPla')"
            style="width:160px;margin-right:20px"
            @change="searchChange"
          >
            <el-option
              v-for="(item, index) in selectOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>

          <zk-dictionary-select v-if="showDevCategory" style="margin-right:20px" :placeholder="$t('device.deviceCategory')" type="devCategory"  v-model="params.devCategory" ></zk-dictionary-select>

          <el-input
            class="search_input_cla"
            clearable
            @clear="searchChange"
            :placeholder="this.$t('common.searchValue')"
            v-model.trim="params.condition"
            @keyup.enter.native="searchChange"
          >
            <el-button
              @click="searchChange"
              slot="append"
              icon="el-icon-search"
            ></el-button>
          </el-input>

          <el-button
            v-if="isCmpDevice"
            type="primary"
            @click="showUpdatedia"
            style="margin-left:20px"
            >{{ $t('device.updateAllDevice') }}</el-button
          >
        </div>

        <div class="deviceList_info_cla">
          <div class="info_item1_cla">
            <i class="icon_cla1"></i>
            <label>{{ $t('device.totalDevice') + '：' }}</label>
            <span>{{ deviceTotal }}</span>
          </div>

          <div class="info_item2_cla">
            <i class="icon_cla2"></i>
            <label>{{ $t('device.online') + '：' }}</label>
            <span>{{ online }}</span>
          </div>

          <div class="info_item3_cla">
            <i class="icon_cla3"></i>
            <label>{{ $t('device.offLine') + '：' }}</label>
            <span>{{ offline }}</span>
          </div>
          <div class="info_item4_cla">
            <i class="icon_cla4"></i>
            <label>{{ $t('device.disbaleDevice') + '：' }}</label>
            <span>{{ disableNum }}</span>
          </div>
        </div>

        <div style="display:flex;">
          <zk-button-group
            @download="download"
            grounpName="downAllDeviceBtnGroup"
            :event="downEvents"
            v-if="deviceList"
          ></zk-button-group>
          <zk-button-group
            @addDevice="addDeviceDia"
            @refresh="refreshEvent"
            :event="events"
            groupName="enterprise_DeviceList_Left"
          ></zk-button-group>
        </div>
      </div>
    </div>

    <div class="black_panel_cla">
      <zk-table
        ref="table"
        :columns="columnData"
        :data="tableData"
        @rowClick="rowClick"
        :stripe="false"
      ></zk-table>
      <!-- <template v-if="!isCmpDevice"> -->
      <div class="pagination-margin-top">
        <el-pagination
          background
          @size-change="changePageSize"
          @current-change="changePage"
          :current-page="pager.curPage"
          :page-size="pager.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pager.total"
        ></el-pagination>
      </div>
      <!-- </template> -->
    </div>

    <el-dialog
      :append-to-body="true"
      width="50%"
      :title="diaTitle"
      @close="closeDia"
      :visible.sync="addDialog"
    >
      <el-form ref="addForm" label-width="180px" :rules="rules" :model="form">
        <el-form-item prop="devSn" :label="this.$t('device.sn')">
          <el-input
            :disabled="isEdit"
            v-model.trim="form.devSn"
            :placeholder="this.$t('device.snRequire')"
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item prop="devAlais" :label="this.$t('device.alias')">
          <el-input
            v-model.trim="form.devAlais"
            autocomplete="off"
            :placeholder="this.$t('device.devAlais')"
          ></el-input>
        </el-form-item>

        <el-form-item prop="deviceTimezone" :label="$t('device.Timezone')">
          <!-- <zk-dictionary-select :clearable="false"
                                type="Timezone"
                                v-model="form.deviceTimezone"
                                style="width: 100%"
                                :placeholder="$t('common.select')"></zk-dictionary-select> -->
          <el-cascader
            style="width:100%"
            v-model="form.timezone"
            :options="timezoneList"
            :props="{ checkStrictly: true, value: 'value', label: 'name' }"
            @change="changeCascader"
            filterable
            clearable
          ></el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.stop="cancelAdd">{{ $t('common.cancel') }}</el-button>
        <el-button @click="submitAdd()" type="primary">
          {{ $t('common.confirm') }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      :append-to-body="true"
      width="30%"
      :title="$t('common.notice')"
      :visible.sync="updateDialog"
    >
      <div v-if="updateStep === 1" class="update-info-box">
        <div>
          <img
            style="width: 150px; height: 150px"
            src="@/assets/new/device/update.svg"
          />
        </div>
        <div>
          <div class="update-item-cla">
            {{ $t('device.allCount') }}:{{ updateInfo.allCount }}
          </div>
          <div class="update-item-cla">
            {{ $t('device.canUpgradeCount') }} :{{ updateInfo.canUpgradeCount }}
          </div>
          <div class="update-item-cla">
            {{ $t('device.noNeedUpgradeCount') }} :{{
              updateInfo.noNeedUpgradeCount
            }}
          </div>
          <div class="update-item-cla">
            {{ $t('device.upgradingCount') }} :{{ updateInfo.upgradingCount }}
          </div>
          <div class="update-item-cla">{{ $t('device.updateConfirm') }}</div>
        </div>
      </div>
      <div style="text-align:center" v-if="updateStep === 2">
        <div>
          <img
            style="width: 150px; height: 150px"
            src="@/assets/new/device/update.svg"
          />
        </div>
        <div>
          {{ $t('device.updateText') }}
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="updateStep === 1" @click="updateDialog = false">{{
          $t('common.cancel')
        }}</el-button>
        <!-- :disabled="updateInfo.noNeedUpgradeCount === 0" -->
        <el-button v-if="updateStep === 1" type="primary" @click="submitUpdate">
          {{ $t('device.upgrade') }}
        </el-button>

        <el-button
          v-if="updateStep === 2"
          type="primary"
          @click="updateDialog = false"
        >
          {{ $t('common.confirm') }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      :append-to-body="true"
      width="30%"
      :title="$t('device.checkTitle')"
      :visible.sync="checkDialog"
    >
      <div>
        <el-steps direction="vertical">
          <el-step icon="el-icon-edit"  :key="item" v-for="item of checkResult">
              <div class="step-icon" :style="{
                color:item.code === '00000000'?'green':'red',
                width: '2rem',
                height: '2rem',
                display: 'flex',
                border: '1px solid red',
                borderColor:item.code === '00000000'?'green':'red',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '2rem',
            }" slot="icon">
                 <i style="position: relative;top: 1px;" v-if="item.code === '00000000'" class="el-icon-check"></i>
                 <i style="position: relative;top: 2px;" v-else class="el-icon-close"></i>
              </div>
              <div  :style="{color:item.code === '00000000'?'green':'red'}" slot="title">{{item.item}}</div>
              <div  style="margin-bottom:20px" slot="description">
                <div  :style="{color:item.code === '00000000'?'green':'red' }" ><span>code : </span><span>{{item.code}}</span></div>
                <div  :style="{color:item.code === '00000000'?'green':'red' }" ><span>message : </span><span>{{item.message || $t('device.checkSuccess')}}</span></div>
              </div>
           </el-step>
        </el-steps>

        <!-- <el-table :data="checkResult" style="width: 100%">
          <el-table-column type="index"> </el-table-column>
          <el-table-column prop="item" :label="$t('device.checkItem')">
          </el-table-column>
          <el-table-column prop="message" :label="$t('device.checkResult')">
            <template slot-scope="scope">
              <span
                style="color:#4db22f"
                v-if="scope.row.code === '00000000'"
                >{{ scope.row.message || $t('device.checkSuccess') }}</span
              >
              <span style="color:red" v-else>{{ scope.row.message }}</span>
            </template>
          </el-table-column>
        </el-table> -->
      </div>
      <div style="text-align: right;margin-top: 20px;">
        <el-button type="primary" @click="checkDialog = false">
          {{ $t('common.confirm') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getDeviceList,
  addDevice,
  updateDevice,
  deleteDevice,
  getTimeZone,
  ufoCount,
  upgradeAll,
  rebootEvent,
  disabledEvent,
  enableEvent
} from '@/services/deviceApi.js'
import { getLanguage } from '@/utils/utils.js'
import { validatorInputEmptyRule } from '@/utils/validatorRule.js'
import {
  findDevicesByCompanyId,
  checkDevice
} from '@/services/companyDevicesApi.js'
import { Loading } from 'element-ui'
export default {
  data() {
    return {
      checkDialog: false,
      checkResult: [],
      updateInfo: {
        allCount: 0,
        canUpgradeCount: 0,
        noNeedUpgradeCount: 0,
        upgradingCount: 0
      },
      updateDialog: false,
      updateStep: 1,
      diaTitle: '',
      appKey: '',
      events: ['refresh', 'addDevice'],
      downEvents: ['download'],
      isEdit: false,
      loadingInstance: null,
      tableData: [],
      x: 100,
      y: 100,
      form: {
        devSn: '',
        devAlais: '',
        deviceTimezone: '+08:00',
        timezone: '',
        companyId: ''
      },
      deviceTotal: 0,
      offline: 0,
      online: 0,
      disableNum: 0,
      querySn: '',
      params: {
        condition: '',
        appKey: '',
        devStatus: '',
        devCategory: ''
      },
      columnData: [],
      showDevCategory: false,
      rules: {
        devSn: validatorInputEmptyRule(true, 32),
        devAlais: validatorInputEmptyRule(false, 64)
      },
      addDialog: false,
      timezoneList: [],
      selectOptions: [
        {
          label: this.$t('device.offLine'),
          value: 0
        },
        {
          label: this.$t('device.online'),
          value: 1
        },
        {
          label: this.$t('device.disbaleDevice'),
          value: 2
        }
      ]
    }
  },
  computed: {
    deviceList() {
      return this.tableData && this.tableData.length
    }
  },
  created() {
    if (this.isCmpDevice) {
      // 企业管理 设备列表tab
      this.getDevicesByCompanyId()
    } else {
      // 设备列表menu
      if (sessionStorage.getItem('loginName') === 'admin') {
        this.events = [' ']
      }
      this.pager.pageSize = 10

      let sn = this.$route.query.sn
      if (sn) {
        this.params.condition = sn
      }
      this.loadingInstance = Loading.service({
        lock: true,
        fullscreen: true,
        text: this.$t('common.refresh'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$nextTick(() => {
        let _self = this
        let t = setTimeout(() => {
          _self.commQuery()
          _self.loadingInstance.close()
          clearInterval(t)
        }, 500)
      })
      this.loadTimeZone()
    }
  },
  mounted() {
    let isCC = this.hasPermission('40491521c7e84973841285ee8e93366b')
    let _self = this
    let columnConfig = [
      {
        label: this.$t('device.sn'),
        prop: 'devSn'
      },
      {
        label: this.$t('device.alias'),
        prop: 'devAlias',
        render: (h, params) => {
          return h('span', {}, _self.isEmpty(params.row.devAlias))
        }
      },
      {
        label: this.$t('device.equipmentStatus'),
        render: (h, params) => {
          let isEnable = params.row.enable
          let a = null

          if (isEnable === 0) {
            a = h(
              'div',
              {
                class: {
                  'device-status-bar-cla': true
                }
              },
              [
                h('div', {
                  class: {
                    'device-disbale-cla': true
                  }
                }),
                h('span', {}, [this.$t('device.disbaleDevice')])
              ]
            )
          } else if (isEnable === 1) {
            if (params.row.devStatus === 1) {
              a = h(
                'div',
                {
                  class: {
                    'device-status-bar-cla': true
                  }
                },
                [
                  h('div', {
                    class: {
                      'device-online-cla': true
                    }
                  }),
                  h('span', {}, [this.$t('device.online')])
                ]
              )
            } else {
              a = h(
                'div',
                {
                  class: {
                    'device-status-bar-cla': true
                  }
                },
                [
                  h('div', {
                    class: {
                      'device-offline-cla': true
                    }
                  }),
                  h('span', {}, [this.$t('device.offLine')])
                ]
              )
            }
          }
          return a
        }
      },
      {
        label: this.$t('device.log.companyName'),
        prop: 'companyName'
      },
      {
        label: this.$t('common.operation'),
        render: (h, params) => {
          let disabledEvents = [
            'enableEvent',
            'rebootEvent',
            'deleteDevice',
            'details'
          ]
          let enableEvents = [
            'disabledEvent',
            'rebootEvent',
            'deleteDevice',
            'details'
          ]

          let event = !params.row.enable ? disabledEvents : enableEvents
          if (params.row.devStatus === 0) {
            event.push('deviceCheck')
          }

          return h('ZkButtonGroup', {
            props: {
              showText: true,
              groupName: 'enterprise_DeviceList_Left_delete',
              showTip: true,
              isLoadGroupName: true,
              params: params.row,
              size: 'mini',
              isGroup: false,
              event: event,
              onlyShowText: true
            },
            on: {
              enableEvent() {
                // 启用
                _self.enableEvent(params.row)
              },
              disabledEvent() {
                // 禁用
                _self.disabledEvent(params.row)
              },
              deleteDevice() {
                // 删除
                _self.deleteDevice(params.row)
              },
              details() {
                // 详情
                _self.details(params.row)
              },
              deviceCheck() {
                _self.check(params.row)
              },
              rebootEvent() {
                _self.rebootEvent(params.row)
              }
            }
          })
        }
      }
    ]
    if (isCC) {
      this.showDevCategory = true
      columnConfig.splice(3, 0, {
        label: this.$t('device.deviceCategory'),
        prop: 'devCategory',
        render: (h, params) => {
          return h('ZkDictionaryValue', {
            key: params.row.devSn,
            props: {
              type: 'devCategory',
              value: params.row.devCategory
            }
          })
        }
      })
      this.columnData = columnConfig
    } else {
      this.showDevCategory = false
      this.columnData = columnConfig
    }
  },
  beforeDestroy() {
    if (
      sessionStorage.getItem('role') === '"superadministrator"' ||
      sessionStorage.getItem('role') === '"operator"'
    ) {
      this.$root.appKey = 'all'
    }
  },

  props: {
    contentHeight: {
      type: Number,
      default: 500
    },
    companyDevice: {
      type: Object
    },
    isCmpDevice: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    // ...mapActions(['setAppKey']),
    showUpdatedia() {
      this.updateStep = 1
      ufoCount({
        companyId: this.companyDevice.id
      })
        .then(data => {
          if (data.code === '00000000') {
            let result = data.payload
            this.updateInfo.allCount = result.allCount
            this.updateInfo.canUpgradeCount = result.canUpgradeCount
            this.updateInfo.noNeedUpgradeCount = result.noNeedUpgradeCount
            this.updateInfo.upgradingCount = result.upgradingCount
            this.updateDialog = true
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => {
          this.errorMessage(e)
        })
    },
    submitUpdate() {
      upgradeAll({
        companyId: this.companyDevice.id
      })
        .then(data => {
          if (data.code === '00000000') {
            this.successMessage(this.$t('device.updateTip'))

            this.updateStep = 2
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => {
          this.errorMessage(e)
        })
    },
    searchChange() {
      if (this.isCmpDevice) {
        this.getDevicesByCompanyId()
      } else {
        this.initQuery()
      }
    },

    check(device) {
      this.loadingInstance = Loading.service({
        lock: true,
        fullscreen: true,
        text: this.$t('device.checkLoading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.checkResult = []
      checkDevice({
        sn: device.devSn
      })
        .then(data => {
          if (data.code === '00000000') {
            this.checkDialog = true
            this.checkResult = data.payload.results
          } else {
            this.$message({
              type: 'error',
              message: data.message || data.msg || 'error'
            })
          }
        })
        .catch(e => {
          this.$message({
            type: 'error',
            message: e.message || e.msg || 'error'
          })
        })
        .finally(() => {
          this.loadingInstance.close()
        })
    },

    getDevicesByCompanyId() {
      let params = {
        companyId: this.companyDevice.id || '',
        ...this.params,
        appKey: this.companyDevice.appKey
      }
      let finallyParams = {
        params,
        pager: this.pager
      }
      findDevicesByCompanyId(finallyParams).then(data => {
        if (data.code === '00000000') {
          this.tableData = data.payload.results

          this.deviceTotal = data.payload.deviceTotal
          this.offline = data.payload.offline
          this.online = data.payload.online
          this.disableNum = data.payload.disableNum

          this.pager.total = data.payload.totalRecords
          this.pager.curPage = data.payload.curPage
          this.pager.pageSize = data.payload.pageSize
        }
      })
    },
    loadTimeZone() {
      getTimeZone()
        .then(data => {
          if (data.code === '00000000') {
            let res = data.payload.results.results
            res.forEach(item => {
              if (item.children && item.children.length === 0) {
                item.children = undefined
              }
            })
            this.timezoneList = res
          } else {
            this.$message.error(data.message)
          }
        })
        .catch(e => {})
    },

    disabledEvent(row) {
      this.$confirm(
        this.$t('device.disabled'),
        this.$t('common.warningNotice'),
        {
          confirmButtonText: this.$t('common.yes'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          this.showLoad()
          let params = {
            deviceSn: row.devSn
          }
          disabledEvent(params)
            .then(this.sucessCallback)
            .catch(this.errorCallback)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.cancelOperation')
          })
        })
    },

    enableEvent(row) {
      this.showLoad()
      let params = {
        deviceSn: row.devSn
      }
      enableEvent(params)
        .then(this.sucessCallback)
        .catch(this.errorCallback)
    },

    details(row) {
      this.$router.push({
        name: 'deviceDetails',
        query: {
          sn: row.devSn,
          companyId: row.companyId,
          isCmp: this.isCmpDevice
        }
      })
    },
    rebootEvent(row) {
      let isOffline = this.showOffLineTip(row)
      if (!isOffline) {
        return false
      }
      this.$confirm(this.$t('device.reboot'), this.$t('common.warningNotice'), {
        confirmButtonText: this.$t('common.yes'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      })
        .then(() => {
          this.showLoad()
          let params = {
            deviceSn: row.devSn
          }

          rebootEvent(params)
            .then(this.sucessCallback)
            .catch(this.errorCallback)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.cancelOperation')
          })
        })
    },

    showOffLineTip(row) {
      if (!(row.enable === 1)) {
        this.$message.error(this.$t('device.enableTip'))
        return false
      }
      if (row.devStatus === 1) {
        return true
      } else {
        this.$message.error(this.$t('device.offLineTip'))
      }
      return false
    },

    deleteDevice(row) {
      this.$confirm(
        this.$t('device.confirmDeleteTip'),
        this.$t('common.confirmDelete'),
        {
          confirmButtonText: this.$t('common.yes'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          let params = {
            devSn: row.devSn
          }
          deleteDevice(params)
            .then(data => {
              if (data.code === '00000000') {
                this.initQuery()
              } else {
                this.errorMessage(data.message)
              }
            })
            .catch(e => {
              this.errorMessage()
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.cancelDelete')
          })
        })
    },

    showLoad() {
      this.loadingInstance = Loading.service({
        lock: true,
        fullscreen: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },

    sucessCallback(data) {
      if (this.loadingInstance) {
        setTimeout(() => {
          this.loadingInstance.close()
        }, 500)
      }
      if (data.code === '00000000') {
        if (this.isCmpDevice) {
          this.getDevicesByCompanyId()
        } else {
          this.commQuery()
        }
      } else {
        this.errorMessage(data.message)
      }
    },
    errorCallback(data) {
      if (this.loadingInstance) {
        this.loadingInstance.close()
      }
      this.errorMessage()
    },

    closeDia() {
      this.$refs.addForm.resetFields()
      this.form.timezone = []
    },
    download() {
      let companyId = sessionStorage.getItem('companyId') || 'all'
      let appKey = this.$root.appKey || 'all'
      let condition = this.params.condition
      let lang = getLanguage()
      let str = !condition
        ? `/apiv1/hr/device/exportExcel?appKey=${appKey}&companyId=${companyId}&lang=${lang}`
        : `/apiv1/hr/device/exportExcel?appKey=${appKey}&companyId=${companyId}&condition=${condition}&lang=${lang}`
      window.open(str)
    },

    addDeviceDia() {
      this.diaTitle = this.$t('device.addDevice')
      this.isEdit = false
      this.form.devSn = ''
      this.form.devAlais = ''
      this.form.deviceTimezone = '+08:00'
      this.addDialog = true
      this.form.timezone = ''
    },
    cancelAdd() {
      this.addDialog = false
    },
    submitAdd() {
      if (!this.isEdit) {
        this.addDevice()
      } else {
        this.updatDevice()
      }
    },
    addDevice() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          let companyCode = sessionStorage.getItem('companyCode')
          if (companyCode) {
            this.form.companyCode = companyCode
          }
          let companyId = sessionStorage.getItem('companyId')
          if (!companyId) {
            this.errorMessage(this.$t('device.noPermission'))
            return false
          }
          try {
            this.form.timezone = this.form.timezone[1]
          } catch (error) {}
          addDevice(this.form)
            .then(data => {
              this.addDialog = false
              if (data.code === '00000000') {
                this.initQuery()
              } else {
                this.errorMessage(data.message)
              }
            })
            .catch(e => {
              this.errorMessage()
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    updatDevice() {
      // 更新設備信息
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.form.timezone = this.form.timezone[1]
          updateDevice(this.form)
            .then(data => {
              this.addDialog = false
              if (data.code === '00000000') {
                this.initQuery()
              } else {
                this.errorMessage(data.message)
              }
            })
            .catch(data => {
              this.errorMessage()
            })
        }
      })
    },
    changePage(current) {
      this.pager.curPage = current

      if (this.isCmpDevice) {
        this.getDevicesByCompanyId()
      } else {
        this.commQuery()
      }
    },
    changePageSize(pageSize) {
      this.pager.pageSize = pageSize
      if (this.isCmpDevice) {
        this.getDevicesByCompanyId()
      } else {
        this.commQuery()
      }
    },
    refreshEvent() {
      this.loadingInstance = Loading.service({
        lock: true,
        fullscreen: true,
        text: this.$t('common.refresh'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.params.searchText = ''
      this.commQuery()
    },
    initQuery() {
      this.pager.curPage = 1
      this.commQuery()
    },
    commQuery(dev) {
      const role = ['"superadministrator"', '"operator"']
      const isAdmin = role.includes(sessionStorage.getItem('role'))
      try {
        this.appKey = this.$route.query.appId
      } catch (e) {}

      if (isAdmin) {
        this.$root.appKey = this.appKey || 'all'
      }

      this.params.appKey = this.$root.appKey || 'all'
      this.params.companyId = sessionStorage.getItem('companyId') || 'all'

      if (this.params.appKey === 'noApp') {
        this.params.appKey = ''
        this.params.companyId = ''
      }

      getDeviceList({
        params: this.params,
        pager: this.pager
      })
        .then(data => {
          if (data.code === '00000000') {
            this.tableData = data.payload.results
            this.pager.total = data.payload.totalRecords
            this.pager.curPage = data.payload.curPage
            this.pager.pageSize = data.payload.pageSize
            this.deviceTotal = data.payload.deviceTotal
            this.offline = data.payload.offline
            this.online = data.payload.online
            this.disableNum = data.payload.disableNum
            if (this.tableData.length > 0) {
              let isSelect = false
              this.querySn = dev
              if (this.querySn) {
                let len = this.tableData.length
                for (let i = 0; i < len; i++) {
                  let item = this.tableData[i]
                  if (item.devSn === this.querySn) {
                    this.$emit('selectRow', item)
                    this.$refs.table.setCurrentRow(item)
                    isSelect = true
                    break
                  }
                }
              }
              if (!isSelect) {
                this.$refs.table.setCurrentRow(this.tableData[0])
                this.$emit('selectRow', this.tableData[0])
              }
            } else {
              this.$emit('selectRow', null)
            }
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => {
          this.errorMessage()
        })
        .finally(() => {
          if (this.loadingInstance) {
            setTimeout(() => {
              this.loadingInstance.close()
            }, 400)
          }
        })
    },
    changeCascader(value) {
      try {
        this.form.deviceTimezone = value[0] || null
        this.timezone = [value[0], value[1]]
      } catch (error) {}
    }
  }
}
</script>

<style scoped lang="less">

@import '~@/styles/var.less';

.step-icon{
    width: 2rem;
    height: 2rem;
    border: 1px solid red;
}
.header_tool_cla {
  display: flex;
  align-items: center;
  justify-items: center;
  justify-content: space-between;
}

.search_bar-cla {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .search_input_cla {
    flex-basis: 320px;
    flex-shrink: 1;
  }
}

.deviceList_info_cla {
  display: flex;

  .info_item_cla {
    padding: 0px 15px;
    height: 20px;
    line-height: 20px;
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;

    label {
      white-space: nowrap;
      font-size: 14px;
    }

    span {
      font-size: 18px;
    }
  }

  .icon_base {
    height: 18px;
    width: 18px;
    margin-right: 8px;
  }

  .info_item1_cla {
    .info_item_cla;

    .icon_cla1 {
      background: center/cover url('~~@/assets/new/image/totalDevice1.svg')
        no-repeat;
      .icon_base();
    }

    span {
      color: @themeColor;
    }
  }

  .info_item2_cla {
    .info_item_cla;

    .icon_cla2 {
      background: center/cover url('~~@/assets/new/image/onlineCount1.svg')
        no-repeat;
      .icon_base();
    }

    span {
      color: @statusSuccess;
    }
  }

  .info_item3_cla {
    .info_item_cla;

    .icon_cla3 {
      background: center/cover url('~~@/assets/new/image/disableCount1.svg')
        no-repeat;
      .icon_base();
    }

    span {
      color: @statusWarning;
    }
  }

  .info_item4_cla {
    .info_item_cla;

    .icon_cla4 {
      background: center/cover url('~~@/assets/new/image/offLineCount1.svg')
        no-repeat;
      .icon_base();
    }

    span {
      color: @ststusFailed;
    }
  }
}

/deep/ .device-status-bar-cla {
  display: flex;
  align-items: center;
}

.update-info-box {
  display: flex;
  align-items: center;
  justify-content: center;
}

.update-item-cla {
  padding-left: 20px;
  height: 40px;
  line-height: 40px;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/deviceManager/deviceManager.vue